import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    
      Created By Rahul Sinha
  </footer>
)

export default Footer
